import tags from "../../components/tags";
import { icons, note } from "../../components/html";
import { statusCodes } from "../../components/responses";

export default {
  "/visitor": {
    get: {
      tags: [tags.sizeIdAccount],
      summary: "Informations about visitor",
      description: `${icons.c}
      Returns all available informations about visitor based on his email or CWID (Cross Web ID). It detects whether or not is registered in SizeID and, if so, returns the visitor's gender information in response.
      ${note("Only one of CWID or email parameter is required")}
      `,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/userEmailIdentifier" },
        { $ref: "#/components/parameters/cwid" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                oneOf: [
                  { $ref: "#/components/schemas/gender" },
                  { type: "null" }
                ],
                example: {
                  gender: {
                    id: "1",
                    label: "Žena"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
